import { useEffect, useRef, useState } from "react";

export const CustomCursor = () => {
  const wrapRef = useRef(null);
  const [enabled] = useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia("(pointer: fine)").matches &&
      window.matchMedia("(prefers-reduced-motion: no-preference)").matches
  );

  useEffect(() => {
    if (!enabled) return;
    const wrap = wrapRef.current;
    let tx = -100;
    let ty = -100;
    let x = tx;
    let y = ty;
    let raf;

    const onMove = (e) => {
      tx = e.clientX;
      ty = e.clientY;
      wrap.classList.add("cursor-visible");
    };
    const onOver = (e) => {
      const interactive = e.target.closest?.(
        'a, button, [role="button"], [data-cursor="hover"]'
      );
      wrap.classList.toggle("cursor-hover", Boolean(interactive));
    };
    const onLeaveDoc = () => wrap.classList.remove("cursor-visible");

    const loop = () => {
      x += (tx - x) * 0.16;
      y += (ty - y) * 0.16;
      wrap.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      raf = requestAnimationFrame(loop);
    };
    loop();

    window.addEventListener("mousemove", onMove, { passive: true });
    document.addEventListener("mouseover", onOver, { passive: true });
    document.documentElement.addEventListener("mouseleave", onLeaveDoc);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseover", onOver);
      document.documentElement.removeEventListener("mouseleave", onLeaveDoc);
    };
  }, [enabled]);

  if (!enabled) return null;

  return (
    <div ref={wrapRef} className="custom-cursor-wrap" data-testid="custom-cursor" aria-hidden="true">
      <div className="custom-cursor-dot" />
    </div>
  );
};
